import { Copy, Share2 } from "lucide-react";
import { toast } from "sonner";
import { rupiah } from "../../lib/api";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { PhotoSlider } from "../PhotoSlider";
import { BuyButtons } from "./BuyButtons";

const WaIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor"><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.5-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6l.4-.5c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.1 4.9 4.3 2.4 1 2.9.8 3.4.7.5-.1 1.7-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.1-.3-.2-.6-.3zM12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.5 1.3 4.9L2 22l5.3-1.4c1.4.8 3 1.2 4.7 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2z"/></svg>
);

export const ProductModal = ({ product, slug, whatsapp, onClose }) => {
  if (!product) return null;
  const url = `${window.location.origin}/${slug}?p=${product.product_id}`;
  const text = `${product.name} - ${rupiah(product.price)}\n${url}`;

  const copy = () => { navigator.clipboard.writeText(url); toast.success("Link produk disalin"); };
  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: product.name, text: product.name, url }); } catch (e) { /* dibatalkan */ }
    } else copy();
  };

  return (
    <Dialog open={!!product} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl p-0 overflow-hidden rounded-2xl max-h-[92vh] overflow-y-auto" data-testid="public-product-modal">
        <div className="grid md:grid-cols-2">
          <PhotoSlider photos={product.photos} arrows interval={3500} testId="modal-photo-slider" />
          <div className="p-6 flex flex-col">
            {product.category && <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">{product.category}</span>}
            <DialogTitle className="mt-1 text-xl font-extrabold tracking-tight" data-testid="modal-product-name">{product.name}</DialogTitle>
            <div className="mt-3 flex items-baseline gap-2">
              <span className="text-2xl font-bold" data-testid="modal-product-price">{rupiah(product.price)}</span>
              {product.original_price > 0 && <span className="text-sm text-slate-400 line-through">{rupiah(product.original_price)}</span>}
              {product.original_price > product.price && (
                <span className="rounded-md bg-red-50 px-1.5 py-0.5 text-xs font-bold text-red-600">-{Math.round((1 - product.price / product.original_price) * 100)}%</span>
              )}
            </div>
            {product.description && <p className="mt-4 text-sm text-slate-600 whitespace-pre-line">{product.description}</p>}
            <div className="mt-auto pt-6 space-y-3">
              <BuyButtons product={product} whatsapp={whatsapp} size="lg" prefix="modal" />
              <div className="grid grid-cols-3 gap-2">
                <a href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer" data-testid="modal-share-whatsapp"
                  className="flex items-center justify-center gap-1.5 rounded-xl border border-slate-200 py-2.5 text-xs font-semibold hover:bg-slate-50"><WaIcon />WhatsApp</a>
                <button onClick={copy} data-testid="modal-copy-link" className="flex items-center justify-center gap-1.5 rounded-xl border border-slate-200 py-2.5 text-xs font-semibold hover:bg-slate-50"><Copy className="h-4 w-4" />Salin link</button>
                <button onClick={share} data-testid="modal-share-button" className="flex items-center justify-center gap-1.5 rounded-xl border border-slate-200 py-2.5 text-xs font-semibold hover:bg-slate-50"><Share2 className="h-4 w-4" />Share</button>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
